<template>
  <div class="calendar-container">
    <div class="calendar-header">
      <div class="start">
        <div class="select is-medium is-primary">
          <select class="select_month" v-model="currentMonth">
            <option
              v-for="month in months"
              :value="month"
              :key="`month_${month}`"
            >
              {{ month }}
            </option>
          </select>
        </div>
        <div class="select is-medium is-primary">
          <select class="select_year" v-model="currentYear">
            <option v-for="year in years" :value="year" :key="`year_${year}`">
              {{ year }}
            </option>
          </select>
        </div>
      </div>
      <div class="end">
        <div class="field has-addons">
          <div class="control">
            <input
              name="name"
              required
              class="input form-element line-input has-text-centered is-secondary has-text-weight-bold"
              type="search"
              autocomplete="false"
              aria-autocomplete="false"
              v-model="eventSearch"
              placeholder="ابحث عن المناسبة "
            />
            <span class="line-control is-secondary"></span>
            <ul class="list-of-events" v-if="eventSearch !== ''">
              <li v-for="event in filteredEvents" :key="`event_${event.id}`">
                <a href="#" @click.prevent="gotoEvent(event.start)">{{event.title}}</a>
              </li>
            </ul>
          </div>
          <div class="control">
            <button type="submit" class="button is-secondary is-inverted"><i class="fas fa-search"></i></button>
          </div>
        </div>
      </div>
    </div>
    <FullCalendar :options="calendarOptions" ref="calendar" />
  </div>
</template>
<script>
import FullCalendar from "@fullcalendar/vue";
import dayGridPlugin from "@fullcalendar/daygrid";
import interactionPlugin from "@fullcalendar/interaction";
import moment from "moment";
import arLocale from "@fullcalendar/core/locales/ar";
// import listPlugin from '@fullcalendar/list';
// import { INITIAL_EVENTS, createEventId } from './event-utils'
export default {
  components: {
    FullCalendar, // make the <FullCalendar> tag available
  },
  props: {
    local: {
      type: String,
      default: "ar",
      required: true,
    },
    yearCount: {
      type: Number,
      default: 5,
      required: false,
    },
    events: {
      type: Array,
      default: () => [""],
      required: false,
    },
  },
  data() {
    return {
      calendarOptions: {
        plugins: [dayGridPlugin, interactionPlugin],
        initialView: "dayGridMonth",
        locale: arLocale,
        events: this.events,
        headerToolbar: {
          left: "",
          center: "title",
          right: "",
        },
      },
      currentMonth: null,
      currentYear: null,
      eventSearch:null
    };
  },
  created() {
    moment.locale("ar");
    this.currentMonth = moment().format("MMMM");
    this.currentYear = moment().locale("en").format("YYYY");
  },
  computed: {
    months() {
      return moment.months();
    },
    years() {
      let years = [];
      for (let index = this.yearCount; index > 0; index--) {
        years.push(moment().year() - index);
      }
      for (let index = 0; index <= this.yearCount; index++) {
        years.push(moment().year() + index);
      }
      return years;
    },
    filteredEvents() {
      if(this.events !== [] ){
        return this.events.filter((event) => {
          return event.title.toLowerCase().includes(this.eventSearch)
        })
      }
    },
  },
  watch: {
    currentMonth: function (val) {
      this.gotoDate();
    },
    currentYear: function (val) {
      this.gotoDate();
    },
  },
  methods: {
    gotoDate() {
      let calendarApi = this.$refs.calendar.getApi();
      let day = moment().format("DD");
      let year = this.currentYear;
      let month = moment().month(this.currentMonth).format("MM");
      let date = `${year}-${month}-${day}`;
      calendarApi.gotoDate(moment(date).locale("en").format("YYYY-MM-DD"));
    },
    gotoEvent(date){
      this.currentYear = moment(date).locale("en").format('YYYY');
      this.currentMonth = moment(date).format("MMMM");
      let calendarApi = this.$refs.calendar.getApi();
      calendarApi.gotoDate(moment(date).locale("en").format("YYYY-MM-D"));
    },

  },
};
</script>
